import { useState } from 'react';
import { authService } from '../services/authService';
import { RegisterCredentials } from '../types/auth.types';
import { handleApiError } from '@/lib/utils/errorHandler';

export const useRegister = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const register = async (credentials: RegisterCredentials): Promise<boolean> => {
    setLoading(true);
    setError(null);

    try {
      await authService.signup(credentials);
      // Signup doesn't automatically log in - user needs to verify email first
      // Don't set auth state here
      return true;
    } catch (err) {
      const apiError = handleApiError(err);
      setError(apiError.message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { register, loading, error };
};
